export const common = {
  // Header
  'header.home': 'Startseite',
  'header.about': 'Über uns',
  'header.faq': 'FAQ',
  'header.contact': 'Kontakt',
  'header.signIn': 'Anmelden',
  'header.getStarted': 'Loslegen',

  // Footer
  'footer.tagline': 'Erhöhen Sie Ihre finanzielle Zukunft',
  'footer.description': 'Sichere, zuverlässige und innovative Zahlungslösungen für Privatpersonen und Unternehmen weltweit.',
  'footer.quickLinks': 'Schnelllinks',
  'footer.services': 'Dienstleistungen',
  'footer.contact': 'Kontaktieren Sie uns',
  'footer.address': '789 Summit Avenue, San Francisco, CA 94102',
  'footer.email': 'support@pinnaclepayments.com',
  'footer.phone': '+1 (415) 555-1234',
  'footer.copyright': '© 2024 Pinnacle Payments. Alle Rechte vorbehalten.',
  'footer.privacy': 'Datenschutzrichtlinie',
  'footer.terms': 'Nutzungsbedingungen',

  // Home Page
  'home.hero.title': 'Erhöhen Sie Ihre finanzielle Zukunft',
  'home.hero.subtitle': 'Erleben Sie nahtloses Banking mit modernster Technologie. Verwalten Sie Ihr Vermögen, investieren Sie intelligent und erreichen Sie Ihre finanziellen Ziele mit Pinnacle Payments.',
  'home.hero.cta': 'Heute beginnen',
  'home.hero.learn': 'Mehr erfahren',

  'home.stats.users': 'Aktive Benutzer',
  'home.stats.countries': 'Bediente Länder',
  'home.stats.transactions': 'Verarbeitete Transaktionen',
  'home.stats.support': '24/7 Support',

  'home.services.title': 'Unsere Premium-Dienstleistungen',
  'home.services.subtitle': 'Umfassende Finanzlösungen, die auf Ihre Bedürfnisse zugeschnitten sind',

  'home.services.banking.title': 'Digitales Banking',
  'home.services.banking.desc': 'Modernes Banking auf Knopfdruck mit Sofortüberweisungen, Rechnungszahlungen und Echtzeit-Kontostandsverfolgung.',

  'home.services.investment.title': 'Investitionslösungen',
  'home.services.investment.desc': 'Vermehren Sie Ihr Vermögen mit unseren kuratierten Anlageportfolios und fachkundiger Finanzberatung.',

  'home.services.loans.title': 'Flexible Kredite',
  'home.services.loans.desc': 'Schnell genehmigte Privat- und Geschäftskredite mit wettbewerbsfähigen Zinssätzen und flexiblen Rückzahlungsbedingungen.',

  'home.services.cards.title': 'Virtuelle Karten',
  'home.services.cards.desc': 'Sichere virtuelle Debit- und Kreditkarten für sicheres Online-Shopping und internationale Transaktionen.',

  'home.features.title': 'Warum Pinnacle Payments wählen',
  'home.features.subtitle': 'Erleben Sie Banking-Exzellenz mit branchenführenden Funktionen',

  'home.features.security.title': 'Banksicherheit',
  'home.features.security.desc': 'Ihre Gelder sind durch militärische Verschlüsselung und Multi-Faktor-Authentifizierung geschützt.',

  'home.features.instant.title': 'Sofortüberweisungen',
  'home.features.instant.desc': 'Senden und empfangen Sie Geld sofort in über 180 Ländern ohne Verzögerungen.',

  'home.features.support.title': '24/7 Experten-Support',
  'home.features.support.desc': 'Unser engagiertes Team steht Ihnen jederzeit zur Verfügung, um Sie bei Fragen oder Anliegen zu unterstützen.',

  'home.features.rates.title': 'Wettbewerbsfähige Tarife',
  'home.features.rates.desc': 'Genießen Sie die besten Wechselkurse und niedrigsten Gebühren der Branche für alle Transaktionen.',

  'home.plans.title': 'Finanzielle Wachstumspläne',
  'home.plans.subtitle': 'Wählen Sie den perfekten Plan, um Ihre finanziellen Ziele zu erreichen',

  'home.plans.dps.title': 'Einzahlungs-Rentensystem',
  'home.plans.dps.rate': 'Jährliche Rendite',
  'home.plans.dps.term': 'Flexible Bedingungen',
  'home.plans.dps.feature1': 'Monatliche Einzahlungsoptionen',
  'home.plans.dps.feature2': 'Garantierte Renditen',
  'home.plans.dps.feature3': 'Steuervorteile',
  'home.plans.dps.feature4': 'Vorzeitige Auszahlungsoption',
  'home.plans.dps.cta': 'Sparen beginnen',

  'home.plans.fdr.title': 'Festgeld-Quittung',
  'home.plans.fdr.rate': 'Zinssatz',
  'home.plans.fdr.term': 'Sperrfrist',
  'home.plans.fdr.feature1': 'Garantiert hohe Renditen',
  'home.plans.fdr.feature2': 'Flexible Laufzeitoptionen',
  'home.plans.fdr.feature3': 'Kredit gegen FDR',
  'home.plans.fdr.feature4': 'Automatische Verlängerung verfügbar',
  'home.plans.fdr.cta': 'Jetzt investieren',

  'home.plans.loan.title': 'Privatkredite',
  'home.plans.loan.rate': 'Ab',
  'home.plans.loan.term': 'Rückzahlungszeitraum',
  'home.plans.loan.feature1': 'Schnelle Genehmigung in 24 Stunden',
  'home.plans.loan.feature2': 'Keine versteckten Gebühren',
  'home.plans.loan.feature3': 'Flexible EMI-Optionen',
  'home.plans.loan.feature4': 'Minimale Dokumentation',
  'home.plans.loan.cta': 'Jetzt bewerben',

  'home.testimonials.title': 'Was unsere Kunden sagen',
  'home.testimonials.subtitle': 'Schließen Sie sich Tausenden zufriedener Kunden weltweit an',

  'home.cta.title': 'Bereit, Ihre finanzielle Zukunft zu transformieren?',
  'home.cta.subtitle': 'Schließen Sie sich Millionen von Benutzern an, die Pinnacle Payments für ihre finanziellen Bedürfnisse vertrauen',
  'home.cta.button': 'Erstellen Sie Ihr Konto',

  // About Page
  'about.hero.title': 'Über Pinnacle Payments',
  'about.hero.subtitle': 'Die Zukunft der digitalen Finanzen seit 2010 führend',

  'about.story.title': 'Unsere Geschichte',
  'about.story.content': 'Pinnacle Payments wurde 2010 gegründet und entstand aus einer Vision, die Finanzdienstleistungsbranche zu revolutionieren. Wir erkannten, dass traditionelles Banking die Bedürfnisse einer sich schnell entwickelnden digitalen Welt nicht erfüllte. Unsere Gründer, ein Team von Fintech-Pionieren und Banking-Veteranen, machten sich daran, eine Plattform zu schaffen, die modernste Technologie mit persönlichem Service verbindet. Heute bedienen wir über 8 Millionen Kunden in 180 Ländern und verarbeiten jährlich Milliarden von Transaktionen, während wir unser Engagement für Sicherheit, Innovation und Kundenzufriedenheit aufrechterhalten.',

  'about.mission.title': 'Unsere Mission',
  'about.mission.content': 'Einzelpersonen und Unternehmen weltweit mit zugänglichen, sicheren und innovativen Finanzlösungen zu befähigen, die es ihnen ermöglichen, ihre Ziele zu erreichen und dauerhaften Wohlstand aufzubauen.',

  'about.vision.title': 'Unsere Vision',
  'about.vision.content': 'Die vertrauenswürdigste digitale Finanzplattform der Welt zu werden und neue Standards für Exzellenz, Sicherheit und Kundenerfahrung in der Fintech-Branche zu setzen.',

  'about.stats.customers': 'Zufriedene Kunden',
  'about.stats.transactions': 'Verarbeitete Transaktionen',
  'about.stats.countries': 'Länder weltweit',
  'about.stats.rating': 'Kundenbewertung',

  'about.values.title': 'Unsere Kernwerte',
  'about.values.security.title': 'Sicherheit zuerst',
  'about.values.security.desc': 'Wir priorisieren die Sicherheit Ihrer Gelder und Daten über alles andere.',
  'about.values.innovation.title': 'Innovation',
  'about.values.innovation.desc': 'Kontinuierliche Weiterentwicklung, um modernste Finanzlösungen bereitzustellen.',
  'about.values.transparency.title': 'Transparenz',
  'about.values.transparency.desc': 'Klare Kommunikation und ehrliche Praktiken in allem, was wir tun.',
  'about.values.excellence.title': 'Exzellenz',
  'about.values.excellence.desc': 'Außergewöhnlichen Service und Ergebnisse für unsere Kunden liefern.',

  'about.team.title': 'Lernen Sie unser Führungsteam kennen',
  'about.team.subtitle': 'Erfahrene Fachleute, die Innovation in Fintech vorantreiben',

  // FAQ Page
  'faq.title': 'Häufig gestellte Fragen',
  'faq.subtitle': 'Finden Sie Antworten auf häufige Fragen zu unseren Dienstleistungen',

  'faq.general': 'Allgemein',
  'faq.account': 'Konto',
  'faq.security': 'Sicherheit',
  'faq.payments': 'Zahlungen',

  // Contact Page
  'contact.title': 'Kontaktieren Sie uns',
  'contact.subtitle': 'Wir sind hier, um bei Fragen oder Anliegen zu helfen',

  'contact.info.title': 'Kontaktinformationen',
  'contact.info.address': 'Besuchen Sie uns',
  'contact.info.email': 'E-Mail an uns',
  'contact.info.phone': 'Rufen Sie uns an',
  'contact.info.hours': 'Geschäftszeiten',
  'contact.info.hoursValue': 'Montag - Freitag: 8:00 - 19:00 Uhr PST',

  'contact.form.title': 'Senden Sie uns eine Nachricht',
  'contact.form.name': 'Vollständiger Name',
  'contact.form.email': 'E-Mail-Adresse',
  'contact.form.subject': 'Betreff',
  'contact.form.message': 'Nachricht',
  'contact.form.send': 'Nachricht senden',

  'contact.map.title': 'Unser Standort',
};

export default common;